<template>
  <div class="sidebar-container2">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        style="font-size=16px !important"
        mode="vertical"
        :default-active="id + ''"
        :unique-opened="true"
        active-text-color="#ffffff"
      >
        <header-sidebar-item
          v-for="menu in menuList"
          :key="menu.id"
          :index="menu.id"
          :id="menu.id"
          :name="menu.name"
          :item="menu"
          @change="change"
        />
      </el-menu>
    </el-scrollbar>
    <div
      v-if="!token"
      class="fay el-submenu__title old-login"
      @click="back('/Login', 10)"
    >
      <img
        src="../assets/image/avatar.jpg"
        alt=""
        style="background-color: #fff"
      />
      登录
    </div>
    <div
      v-else
      class="fay el-submenu__title new-login"
      @click="back('/PersonalCenter')"
    >
      <img :src="img" alt="" style="background-color: #fff" />
      个人中心
    </div>
  </div>
</template>
<script>
import HeaderSidebarItem from "./HeaderSidebarItem.vue";

export default {
  name: "HeaderSidebar",
  components: { HeaderSidebarItem },
  props: {
    menuList: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  watch: {
    $route(newValue, oldValue) {
      this.info();
    },
    $route(newValue, oldValue) {
      this.n = 1;
      if (this.$route.query && this.$route.query.name) {
        for (const index in this.menuList) {
          if (this.$route.query.name == this.menuList[index].name) {
            this.n = parseInt(index) + 2;
          }
        }
      }
    },
  },
  mounted() {},
  methods: {
    
    change(item) {
      this.$emit("change", item);
    },
    back(i, idx) {
      this.n = idx;
      this.$router.push(i);
      this.$emit("drawerClose");
    },
  },
};
</script>
<style lang="scss">
.sidebar-container2 {
  transition: width 0.28s;
  .old-login img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .new-login img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .scrollbar-wrapper {
    overflow-x: hidden !important;
    margin-bottom: 0 !important;
    // background-color: #000 !important;
    .el-scrollbar__view {
      height: 100%;
    }
  }
  .el-submenu__title:last-child {
    border-bottom: 1px solid #ffffff !important;
  }
  .el-submenu__title {
    font-size: 16px;
    background-color: #c11226  !important;
    color: #fff !important;
    border-top: 1px solid #ffffff !important;
    @media (max-width: 300px) {
      font-size: 14px !important;
    }
  }
  .el-menu-item {
    background-color: #fff  !important;
    color: #000 !important;
    // border-top: 1px solid #ffffff50 !important;
    font-size: 16px !important;
    @media (max-width: 300px) {
      font-size: 14px !important;
    }
  }
  // .el-scrollbar__wrap {
  //   margin-bottom: 0 !important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderSideBar.vue